import Component from '@glimmer/component';
import ImportModel from 'cio/models/import';
import { IdentifierKey, IdentifierState } from 'cio/utils/identifiers';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    import: ImportModel;
  };
}

export default class SummaryOverview extends Component<Signature> {
  @service environment!: EnvironmentService;
  readonly identifierKey = IdentifierKey;

  get newProfileCount() {
    let { isEventsImport, validateMeta, newProfileCount } = this.args.import;
    if (isEventsImport) {
      return validateMeta?.newProfiles ?? 0;
    }

    return newProfileCount;
  }

  // Only show ID Changes over Email changes if the update was by email and the ID identifier is
  // mutable in the workspace
  get showIdChanges() {
    return (
      this.args.import.identifier === IdentifierKey.Email &&
      this.environment.current.identifiers[IdentifierKey.Id] === IdentifierState.Enabled
    );
  }

  get objectTypeSingularName() {
    let { objectType } = this.args.import;

    return objectType ? objectType.singularName : 'object';
  }
}
